// extracted by mini-css-extract-plugin
export default {"content":"Y44gqv2RGG2nBjNX4VJZ","subtitle":"ki3OMo6jUdgtQyMwZrA_","pdfWithoutBorder":"FnWXlDdcNFHwI9xbFADI","footer":"ZsbFPiRnEySavBsaY1LD","actions":"QemcaoUeIEzw5keoGgVs"};